import { schema } from 'normalizr';

export const appointmentSchema = new schema.Entity('appointments', {}, { idAttribute: '_id' });
export const appointmentListSchema = [appointmentSchema];
